import {
  BarChart,
  TotalMileageCard,
  AverageSpeed,
  TotalDrivingTimeHrs,
  DailyMileage,
  Average_consumption_speed_class,
  Yearly_mileage,
  Start_of_data_acquisition,
  Total_Standing_time,
  Energy_consumption_bbp,
  Energy_consumption_cbp,
  NetEnergyConsumption,
  EnergyRecuperated,
  AmbientTemperature,
  Energy_consumption_per_speed_class_BBP
  

} from './ride_analysis_kpi';
import RideDataDownload from './ride_analysis_kpi/RideDataDownload';
import { ManText } from "@craft-design-system/core-components-react";
import { useGraphContext } from '../GraphContext';
import { Card } from 'react-bootstrap';
import { useState } from 'react';

const Ride_Analysis = () => {
  const { graphData } = useGraphContext();

  const {
    total_mil,
    start_of_data_acquisition,
    median_consum,
    vin_short,
    daily_mileage,
    startDate,
    endDate,
    average_consumption_per_speed_class_standing,
    yearly_mileage,
    average_speed,
    total_driving_time,
    total_standing_time,
    daily_mileage_statement,
    energy_throughput_statement,
    daily_avgspeed_statement,
    daily_standing_time_statement,
    daily_driving_statement,
    energy_consumption_BBP,
    energy_consumption_CBP,
    netEnergyConsumption,
    RecuperatedEnergy,
    Ambienttemperature,
    agent_insight,
    Standstill_BBP


  } = graphData;
   
  // 🆕 Add chartType state here
  const [chartType, setChartType] = useState("Bar");

  return (
    <div>
      {/* Date Range Download Component */}
      <RideDataDownload />
      
      <div className="card-info1">
        <TotalMileageCard value={{ total_mil, vin_short }} />
        <Start_of_data_acquisition value={start_of_data_acquisition} />
        <Energy_consumption_cbp value={{ energy_consumption_CBP, vin_short, daily_standing_time_statement }} />
        <Energy_consumption_bbp value={{ energy_consumption_BBP, vin_short, daily_standing_time_statement }} /> 
        <EnergyRecuperated value={{ RecuperatedEnergy, vin_short, agent_insight }} />
        <NetEnergyConsumption value={{ netEnergyConsumption, vin_short, agent_insight }} />
        <BarChart value={{ median_consum, vin_short, agent_insight }} />
        <AmbientTemperature value={{ Ambienttemperature, vin_short, agent_insight }} />
        <DailyMileage
            value={{ daily_mileage, vin_short, agent_insight,startDate,endDate }}
          />
        <AverageSpeed value={{ average_speed, vin_short, agent_insight }} />
        <Yearly_mileage value={yearly_mileage} />
        <Total_Standing_time value={{ total_standing_time, vin_short, agent_insight}} />
        <TotalDrivingTimeHrs value={{ total_driving_time, vin_short, agent_insight }} />
        <Average_consumption_speed_class value={{ standstill_consumption: average_consumption_per_speed_class_standing, vin_short }} />
        <Energy_consumption_per_speed_class_BBP value={{ standstill_consumption_BBP:Standstill_BBP, vin_short }} />
      </div>
    </div>
  );
};

export default Ride_Analysis;

